import { render } from "./CovidDrive.vue?vue&type=template&id=36629b9f"
import script from "./CovidDrive.vue?vue&type=script&lang=js"
export * from "./CovidDrive.vue?vue&type=script&lang=js"

import "./CovidDrive.vue?vue&type=style&index=0&id=36629b9f&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CovidDrive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36629b9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36629b9f', __exports__)) {
    console.log('reload')
    api.reload('36629b9f', __exports__)
  }
  
  module.hot.accept("./CovidDrive.vue?vue&type=template&id=36629b9f", () => {
    console.log('re-render')
    api.rerender('36629b9f', render)
  })

}


export default __exports__